<script setup>
    import { ref } from 'vue'
    import IconChevron from "../../icons/iconChevron.vue";

    const props = defineProps({
       item: {
          type: Object,
          required: true
       }
    });

    const navigationExpanded = ref(false)

    const toggleNavigation = () => {
        navigationExpanded.value = !navigationExpanded.value
    }

</script>
<template>
    <div>
        <div
            class="w-full flex items-center justify-between pl-2 group"
        >
            <slot></slot>
            <button
                v-if="item.subItems?.length > 0"
                @click="toggleNavigation"
                class="relative flex h-full w-11 justify-start items-center"
            >
                <icon-chevron
                    class="h-6 w-6 transform transition"
                    :class="navigationExpanded ? 'rotate-180 fill-current opacity-90' : 'fill-current'"
                />
            </button>
        </div>
        <div
            v-if="item.subItems?.length > 0"
            class="w-full"
            :class="navigationExpanded ? 'block' : 'hidden'"
        >
            <ul
                class="ml-4 px-2 my-2"
            >
                <li
                    v-for="(subItem, i) in item.subItems.filter(si => si.visible === true)"
                    class="px-1 py-2"
                >
                    <a
                        :href="subItem.href"
                        class="hover:underline hover:outline-none mf-link-immune"
                    >
                        {{ subItem.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
